import { Injectable } from "@angular/core";
import * as dayjs from "dayjs";

@Injectable({
  providedIn: "root",
})
export class DateHelperService {
  startOfWeek = 'mon';
  constructor() {
  }

  setStartOfWeek(day:string){
    this.startOfWeek = day;
  }
  getCurrentWeek() {
    const now = dayjs();
    return this.getWeekFor(now);
  }

  getLastWeek() {
    const now = dayjs().subtract(7,'d');
    return this.getWeekFor(now);
  }

  getLast4tWeeks() {
    var weekStart = dayjs().subtract(3, "weeks");

    let weekStartDay;
    for (let i = 0; i < 7; i++) {
      if(dayjs(weekStart).subtract(i, "days").format('ddd').toLowerCase() == this.startOfWeek){
        weekStartDay = dayjs(weekStart).subtract(i, "days");
      }
    }



    var days = [];
    for (var i = 0; i < 28; i++) {
      days.push(dayjs(weekStartDay).clone().add(i, "day").toDate());
    }
    return days;
  }
  getWeekKey(week: any) {
    return (
      dayjs(week[0]).format("YYYY-MM-DD") +
      "_" +
      dayjs(week[6]).format("YYYY-MM-DD")
    );
  }

  getWeekFor(dateTime: any): Date[] {
      const days = [];
      // work out start
      let startOfWeek;
      for (let i = 0; i < 7; i++) {
        if(dayjs(dateTime).subtract(i, "days").format('ddd').toLowerCase() == this.startOfWeek){
          startOfWeek = dayjs(dateTime).subtract(i, "days");
        }
      }

      for (let i = 0; i < 7; i++) {
        days.push(dayjs(startOfWeek).add(i, "days").toDate());
      }

     /* const monday = dayjs(dateTime).startOf("week");
      days.push(monday.toDate());
      for (let i = 1; i < 7; i++) {
        days.push(dayjs(monday).add(i, "days").toDate());
      }*/
      return days;
  }

  getWeekDayFor(dateTime: any): Date[] {
    const days = [];

    let startOfWeek;
    for (let i = 0; i < 7; i++) {
      if(dayjs(dateTime).subtract(i, "days").format('ddd').toLowerCase() == this.startOfWeek){
        startOfWeek = dayjs(dateTime).subtract(i, "days");
      }
    }
    days.push(dayjs(startOfWeek).toDate());


    for (let i = 1; i < 5; i++) {
      days.push(dayjs(startOfWeek).add(i, "days").toDate());
    }

    return days;
  }

  shiftWeek(add: number, dateTime: any) {
    // this will just increment or decrement the week
    const sunday = dayjs(dateTime).startOf("week");
    sunday.add(1, "d");

    if (add) {
      sunday.add(1, "w");
    } else {
      sunday.subtract(1, "w");
    }

    return sunday;
  }

  getWeekDate(dateTime: any) {
    const sunday = dayjs(dateTime).startOf("week");

    const monday = sunday.add(1,'day').clone();

    return "Week Commencing " + monday.format("Do");
  }

  getStartOfWeek(dateTime: any) {
    const sunday = dayjs(dateTime).startOf("week");

    const monday = sunday.add(1, 'day').clone();

    return monday;
  }

  formatDate(date: any, format: string) {
    return dayjs(date).format(format);
  }

  getToday() {
    return dayjs().format("YYYY-MM-DD");
  }
}
